var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-3 py-1"},[_c('RuleSmallButton',{staticClass:"focus-style btn-secondary my-2",attrs:{"title":_vm.trans(`subscription.validation_rules.description_add`),"type":"button"},nativeOn:{"click":function($event){return _vm.addRuleProperty()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }